export default __webpack_public_path__ + "static/media/background-2.46e425a6.png";